var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 11H12.1844L11.8954 10.73C12.907 9.59 13.516 8.11 13.516 6.5C13.516 2.91 10.5122 0 6.80636 0C3.10055 0 0.0966797 2.91 0.0966797 6.5C0.0966797 10.09 3.10055 13 6.80636 13C8.46829 13 9.99603 12.41 11.1728 11.43L11.4515 11.71V12.5L16.6128 17.49L18.1509 16L12.9999 11ZM6.80636 11C4.23603 11 2.1612 8.99 2.1612 6.5C2.1612 4.01 4.23603 2 6.80636 2C9.37668 2 11.4515 4.01 11.4515 6.5C11.4515 8.99 9.37668 11 6.80636 11ZM9.387 6H4.22571V7H9.387V6Z",
    fill: "#EFF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/ZoomOutIcon.31bd4cd5.svg";
export { ForwardRef as ReactComponent };